import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { fetchQuickLinks } from "../../helper/Api";
import "./QuickLinksModal.css";

const QUICK_LINK_COLORS = [
  "#2590ea",
  "#198754",
  "#6f42c1",
  "#fd7e14",
  "#dc3545",
  "#20c997",
  "#0dcaf0",
  "#0d6efd",
];

const quickLinkColorFor = (seed) => {
  const s = String(seed ?? "");
  let hash = 0;
  for (let i = 0; i < s.length; i += 1) {
    hash = (hash * 31 + s.charCodeAt(i)) | 0;
  }
  return QUICK_LINK_COLORS[Math.abs(hash) % QUICK_LINK_COLORS.length];
};

const normalizeQuickLinks = (list = []) => {
  const addNewEntity = list
    .filter((x) => Number(x?.type) === 1)
    .map((x, idx) => ({
      id: x?.id ?? `type1-${idx}`,
      label: x?.title || "",
      to: x?.link || "#",
    }))
    .filter((x) => x.label);

  const reports = list
    .filter((x) => Number(x?.type) === 2)
    .map((x, idx) => ({
      id: x?.id ?? `type2-${idx}`,
      label: x?.title || "",
      to: x?.link || "#",
    }))
    .filter((x) => x.label);

  return { addNewEntity, reports };
};

const QuickLinksModal = ({ open, onClose }) => {
  const [quickLinks, setQuickLinks] = useState({ addNewEntity: [], reports: [] });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return undefined;

    let isMounted = true;

    (async () => {
      try {
        setLoading(true);
        const res = await fetchQuickLinks();
        const list = res?.data?.result || [];

        if (isMounted) {
          setQuickLinks(normalizeQuickLinks(list));
        }
      } catch (error) {
        console.error("fetchQuickLinks failed", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [open]);

  const renderLinks = (links) => {
    if (!links.length) {
      return <p className="quick-links-modal__empty">No links available</p>;
    }

    return (
      <ul className="quick_links_list">
        {links.map((link) => (
          <li key={link.id} className="quick_links_item">
            <Link
              to={link.to}
              className="quick_link_badge"
              style={{ backgroundColor: quickLinkColorFor(link.id || link.label) }}
              onClick={onClose}
            >
              <span>{link.label}</span>
              <i className="icon-open_in_new quick_link_icon" />
            </Link>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      size="xl"
      dialogClassName="quick-links-modal__dialog"
      className="quick-links-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Quick Links</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <p className="quick-links-modal__loading">Loading quick links...</p>
        ) : (
          <table width="100%" className="quick_links_table" border="1">
            <thead>
              <tr className="quick-links-modal__header-row">
                <th>Actions</th>
                <th>Reports</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{renderLinks(quickLinks.addNewEntity)}</td>
                <td>{renderLinks(quickLinks.reports)}</td>
              </tr>
            </tbody>
          </table>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default QuickLinksModal;
